import { EventEmitter } from 'eventemitter3';
const createCustomerStore = () => {
    let customer = {
        preferredIssuerCode: '',
        isCustomerLoaded: false,
    };
    const eventEmitter = new EventEmitter();
    return {
        getSnapshot: () => customer,
        subscribe: (callback) => {
            eventEmitter.addListener('update', callback);
            return () => {
                eventEmitter.removeListener('update', callback);
            };
        },
        setPreferredIssuer: (preferredIssuerCode) => {
            customer = { ...customer, preferredIssuerCode };
            eventEmitter.emit('update');
        },
        getPreferredIssuer: () => customer.preferredIssuerCode,
        setIsCustomerLoaded: (isCustomerLoaded) => {
            customer = { ...customer, isCustomerLoaded };
            eventEmitter.emit('update');
        },
        getIsCustomerLoaded: () => customer.isCustomerLoaded,
    };
};
export const customerStore = createCustomerStore();
export const setPreferredIssuer = (preferredIssuerCode) => {
    console.log('Setting preferred issuer code:', preferredIssuerCode);
    customerStore.setPreferredIssuer(preferredIssuerCode);
    console.log(preferredIssuerCode);
    setPreferredIssuer(preferredIssuerCode);
    console.log('Customer preferred issuer set:', preferredIssuerCode);
};
export const setIsCustomerLoaded = (isCustomerLoaded) => {
    console.log('Setting isCustomerLoaded:', isCustomerLoaded);
    customerStore.setIsCustomerLoaded(isCustomerLoaded);
    console.log(isCustomerLoaded);
    setIsCustomerLoaded(isCustomerLoaded);
    console.log('isCustomerLoaded set to:', isCustomerLoaded);
};
